<!-- //
变量定义
@auth xuyd
@date 2025-07-20
//-->
<template>
  <page-layout layout="C">
    <!-- 检索区域 -->
    <div class="layout-search flex-row flex-halign-between">
      <el-form @submit.native.prevent ref="refQueryForm" :model="queryParams" size="small" :inline="true"
               label-width="100px">
        <el-form-item prop="search">
          <el-input
              v-model="queryParams.search"
              placeholder="请输入变量名/变量值"
              style="width: 320px;text-align: right;"
              maxlength="20"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleQuery" icon="el-icon-search">检索</el-button>
          <el-button size="small" type="primary" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display:flex;">
        <div>
          <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus">添加</el-button>
        </div>
      </div>
    </div>

    <div class="layout-result" style="height: calc(100% - 63px);">
      <DynamicTable :query-params="queryParams"
                    :selection="true"
                    :data="tableData"
                    :metas="tableMetas"
                    @reload="getList">
        <div slot-scope="{row, item}">
          <el-button size="small" type="text" @click="handleView(row)">查看</el-button>
          <el-button size="small" type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button size="small" type="text" @click="handleCopy(row)">复制</el-button>
          <el-button size="small" type="text" @click="handleDelete(row)">删除</el-button>
        </div>
      </DynamicTable>
    </div>
    <VariableDetail ref="refVariableDetail"/>
  </page-layout>
</template>

<script>
import VariableApi from '@/api/sys/sysVariable.api.js';
import VariableDetail from './detail';

export default {
  name: 'ViewVariableList',
  components: {VariableDetail},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
    {dictType: 'ENV_TYPE', dataType: String},
  ],
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: null,
        isAsc: null,
        search: null,
      },
      tableData: {
        tableLoading: false,
        records: [],
        total: 0,
      },
      tableMetas: [
        {prop: 'variableName', label: "变量名", width: 180},
        {prop: 'variableValue', label: "变量值", minWidth: 300, showOverflow: true},
        {prop: 'variableDesc', label: "变量描述", width: 200},
        {prop: '', label: "操作", width: 180, fixed: 'right'},
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      VariableApi.searchVarList(this.queryParams).then(resp => {
        this.tableData.records = resp.data.records;
        this.tableData.total = resp.data.total;
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm("refQueryForm");
      this.$refs.refQueryForm.resetFields();
      this.queryParams.orderByColumn = null;
      this.queryParams.isAsc = null;

      // =========重置(S)========
      // =========重置(E)========
      this.handleQuery();
    },

    /** 排序触发事件 */
    handleSortChange(column) {
      // console.log("----handleSortChange---->", JSON.stringify(column));
      if (column.order === 'ascending') {
        this.queryParams.isAsc = true;
        this.queryParams.orderByColumn = column.prop;
      } else if (column.order === 'descending') {
        this.queryParams.isAsc = false;
        this.queryParams.orderByColumn = column.prop;
      } else {
        this.queryParams.isAsc = null;
        this.queryParams.orderByColumn = null;
      }
      this.getList();
    },
    handleAdd() {
      this.$refs.refVariableDetail.showModal({
        mode: 1,
        title: '新增',
        data: {},
        onOk: (data) => {
          this.getList()
        }
      });
    },

    handleView(row) {
      this.$refs.refVariableDetail.showModal({
        mode: 3,
        title: '查看',
        data: {...row},
        onOk: (data) => {
        }
      });
    },
    handleEdit(row) {
      this.$refs.refVariableDetail.showModal({
        mode: 2,
        title: '修改',
        data: {...row},
        onOk: (data) => {
          this.getList()
        }
      });
    },
    handleCopy(row) {
      this.$refs.refVariableDetail.showModal({
        mode: 1,
        title: '新增',
        data: {...row, id: null},
        onOk: (data) => {
          this.getList()
        }
      });
    },
    handleDelete(row) {
      this.$modal.confirm(`确定要删除【${row.variableName}】吗？`).then(() => {
        VariableApi.deleteVar(row.id).then(resp => {
          this.$modal.msgSuccess('删除成功');
          this.getList();
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>

</style>
